import { biHottag } from '@tencent/ppd-base-libs';
import { ABTestInfo } from './ab-test';

let abTestInfo: ABTestInfo | {} = {};

/**
 * 设置 ABT 信息，bi上报时在基础字段中带上。 需要注意 调用顺序，先设置 ABT 信息，再调用 biHT 上报
 * */
export const setABTestInfo = (info: ABTestInfo) => {
  abTestInfo = { ...info };
  console.log('setABTestInfo', abTestInfo);
};

export function biHT(stat: string, ext = {}) {
  biHottag(stat, {
    ...ext,
    // ...abTestInfo, // 下架abt
  });
}

// eslint-disable-next-line camelcase
export const isABTestInfoEmpty = () => {
  console.log('===abtInfo', abTestInfo);
  return !(abTestInfo as any).report_info;
};
